import React, {PropTypes} from 'react';
import {I18n} from 'react-redux-i18n';
import firstBy from 'thenby';

class LabelSizeList extends React.Component {
  handleSizeChange = (e) => {
    this.props.onSelected(e.target.value);
  }

  render() {
    const {activeSize, definitions} = this.props;

    definitions.sort(firstBy("Height").thenBy("Width"));

    
    const definitionNames = definitions.map((definition) => {
      return <option key={definition.LabelName} value={definition.LabelName}>{definition.LabelName}</option>;
    });

    return (
      <div className="col-xl-12 col-sm-2">
        <label className="lbl-label-size" htmlFor="label-size">{I18n.t('LABEL_SIZE')}</label>
        <label className="select">
        <select id="label-size" defaultValue={activeSize} onChange={(e) => {this.handleSizeChange(e);}}>
          {definitionNames}
        </select>
        </label>
      </div>
    );
  }
}

LabelSizeList.propTypes = {
  activeSize: PropTypes.string.isRequired,
  definitions: PropTypes.array.isRequired,
  onSelected: PropTypes.func.isRequired
};

export default LabelSizeList;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/LabelSizeList.js
 **/